import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const orgContragentsService = {
  Get,
  Find,
  Add,
  Edit,
  Del,
  GetUsers
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  }
};

function extract(r) {
  return r.data;
}

async function Get(isUnique: boolean = false) {
  return axios.get(model.baseUrl + `OrganisationContragent?isUnique=${isUnique}`).then(extract);
}

function Find(searchParam: string) {
  return axios.get(model.baseUrl + 'OrganisationContragent/find' + `?searchParam=${searchParam || ''}`).then(extract);
}

async function Add(
  contragentEDRPO,
  contragentNameUk,
  contragentNameRu,
  contragentNameEn,
  contragentSmallNameUk,
  contragentSmallNameRu,
  contragentSmallNameEn,
  contragentEmail,
  contragentPhone,
  contragentAddress,
  contragentIBAN,
  contragentFioSigner,
  contragentFioSignerRod,
  contragentBaseDocument
) {
  return axios
    .put(model.baseUrl + 'OrganisationContragent', {
      contragentEDRPO,
      contragentNameUk,
      contragentNameRu,
      contragentNameEn,
      contragentSmallNameUk,
      contragentSmallNameRu,
      contragentSmallNameEn,
      contragentEmail,
      contragentPhone,
      contragentAddress,
      contragentIBAN,
      contragentFioSigner,
      contragentFioSignerRod,
      contragentBaseDocument
    })
    .then(extract);
}

async function Edit(
  organisationContragentGuid,
  contragentEDRPO,
  contragentNameUk,
  contragentNameRu,
  contragentNameEn,
  contragentSmallNameUk,
  contragentSmallNameRu,
  contragentSmallNameEn,
  contragentEmail,
  contragentPhone,
  contragentAddress,
  contragentIBAN,
  contragentFioSigner,
  contragentFioSignerRod,
  contragentBaseDocument) {
  return axios
    .patch(model.baseUrl + 'OrganisationContragent', {
      organisationContragentGuid,
      contragentEDRPO,
      contragentNameUk,
      contragentNameRu,
      contragentNameEn,
      contragentSmallNameUk,
      contragentSmallNameRu,
      contragentSmallNameEn,
      contragentEmail,
      contragentPhone,
      contragentAddress,
      contragentIBAN,
      contragentFioSigner,
      contragentFioSignerRod,
      contragentBaseDocument
    })
    .then(extract);
}
async function Del(ids: string[]) {
  return axios
    .delete(model.baseUrl + 'OrganisationContragent',
      { data: ids }
    ).then(extract);
}

async function GetUsers(contragentGuid: string, searchParam: string) {
  return axios
    .get(`${model.baseUrl}OrganisationContragent/users?contragentGuid=${contragentGuid}&searchParam=${searchParam || ''}`)
    .then(extract);
}
